/**
 * Estados de tela (U1): carregamento com skeleton e vazio com ação sugerida.
 */
import { Skeleton, Stack, Text, Button, Group, ThemeIcon } from "@mantine/core";
import { IconMoodEmpty } from "@tabler/icons-react";

/** Bloco de carregamento padrão (linhas de skeleton no lugar da lista). */
export function Carregando({ linhas = 4 }: { linhas?: number }) {
  return (
    <Stack gap="xs" role="status" aria-label="Carregando">
      {Array.from({ length: linhas }, (_, i) => (
        <Skeleton key={i} height={28} radius="sm" />
      ))}
    </Stack>
  );
}

/** Estado vazio com texto e ação sugerida. */
export function Vazio({
  texto,
  acao,
  onAcao,
}: {
  texto: string;
  acao?: string;
  onAcao?: () => void;
}) {
  return (
    <Group gap="sm" py="md" justify="center">
      <ThemeIcon variant="light" color="gray" size="lg">
        <IconMoodEmpty size={20} />
      </ThemeIcon>
      <Text c="dimmed" size="sm">
        {texto}
      </Text>
      {acao && onAcao && (
        <Button size="xs" variant="light" onClick={onAcao}>
          {acao}
        </Button>
      )}
    </Group>
  );
}
